import { queryKeys } from '../queryKeys'
import { auditAiRequest } from '../../util/api/audit-ai-api'
import { createDashboardTableHook } from './dashboardHookUtils'
import type {
  DashboardClinicianTableResponse,
  DashboardSortableTableOptions,
} from '@counsel-project/counsel-audit-ai-api'

type UseDashboardTableCliniciansOptions = {
  sortBy?: DashboardSortableTableOptions['sortBy']
  sortOrder?: DashboardSortableTableOptions['sortOrder']
}

export const useDashboardTableClinicians = createDashboardTableHook<
  DashboardClinicianTableResponse,
  UseDashboardTableCliniciansOptions
>({
  buildQueryKey: queryKeys.dashboardTableClinicians,
  request: auditAiRequest.dashboard.tableClinicians,
  paginationMode: 'local',
  defaultRowsPerPage: 10,
  getOptionSortBy: (options) => options.sortBy,
  getOptionSortOrder: (options) => options.sortOrder,
})
